import React from 'react';
import { Box, Card, CardActionArea, CardContent, Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const BattlemapCard = styled(Card)(({ theme, selected }) => ({
  borderRadius: theme.shape.borderRadius,
  border: selected ? `2px solid ${theme.palette.secondary.main}` : '2px solid transparent',
  backgroundColor: selected ? 'rgba(218, 165, 32, 0.15)' : 'rgba(0, 0, 0, 0.2)',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: 'rgba(218, 165, 32, 0.08)',
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[4],
  },
}));

function BattlemapThumbImg({ src, alt }) {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
    />
  );
}

const BattlemapsCard = ({
  selected = false,
  onClick,
  thumbnail,
  alt,
  title,
  subtitle,
  gridWidth,
  gridHeight,
  previewHeight = 80,
  chipLabel = null,
  emptyStateText = 'No preview',
  titleFontSize = '.9rem',
  subtitleFontSize = '0.6rem',
}) => (
  <BattlemapCard selected={selected}>
    <CardActionArea onClick={onClick}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: previewHeight,
          overflow: 'hidden',
          borderRadius: '4px 4px 0 0',
        }}
      >
        {thumbnail ? (
          <BattlemapThumbImg src={thumbnail} alt={alt || title} />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px dashed rgba(218, 165, 32, 0.3)',
            }}
          >
            <Typography sx={{ color: 'text.secondary', fontSize: '0.8rem' }}>{emptyStateText}</Typography>
          </Box>
        )}
        {chipLabel && (
          <Chip
            label={chipLabel}
            size="small"
            color="primary"
            sx={{
              position: 'absolute',
              top: 6,
              right: 6,
              fontWeight: 600,
              fontSize: '0.75rem',
              height: 24,
              '& .MuiChip-label': { px: 0.75 },
            }}
          />
        )}
      </Box>
      <CardContent sx={{ py: 1, px: 1 }}>
        {title && (
          <Typography
            variant="caption"
            sx={{
              fontFamily: 'MedievalSharp',
              textAlign: 'center',
              display: 'block',
              fontSize: titleFontSize,
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              textAlign: 'center',
              display: 'block',
              fontSize: subtitleFontSize,
            }}
          >
            {subtitle}
          </Typography>
        )}
        {gridWidth > 0 && (
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              textAlign: 'center',
              display: 'block',
              fontSize: '0.6rem',
            }}
          >
            {gridWidth}×{gridHeight}
          </Typography>
        )}
      </CardContent>
    </CardActionArea>
  </BattlemapCard>
);

export default BattlemapsCard;
